module.exports = __webpack_public_path__ + "img/success-payment.99d01e9b.svg";